import { Typography, Link } from '@mui/material';
import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import axios from "axios";
import AuthLayout from '../components/AuthLayout';
const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [remainingTime, setRemainingTime] = useState(0);
    useEffect(() => {
        let timer;
        if (remainingTime > 0) {
            timer = setInterval(() => {
                setRemainingTime((prev) => prev - 1);
            }, 1000);
        }
        return () => {
            if (timer)
                clearInterval(timer);
        };
    }, [remainingTime]);
    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };
    const handleKeyDown = (key) => {
        if (key === 'Enter' && remainingTime === 0) {
            submit();
        }
    };
    const submit = () => {
        if (email == "" || remainingTime > 0) {
            return;
        }
        else {
            let data = new FormData();
            data.append('email', email);
            axios({
                method: "post",
                url: "/auth/forgot-password",
                data: data,
                headers: { "Content-Type": "multipart/form-data" },
            })
                .then(function (response) {
                if (response.data.success) {
                    setSnackbarSeverity('success');
                    setSnackbarMessage(response.data.message || 'Инструкции отправлены на ваш email');
                    setOpenSnackbar(true);
                    setEmail('');
                    setRemainingTime(120); // 2 минуты = 120 секунд
                }
                else {
                    // Если success = false, показываем ошибку через Snackbar
                    setSnackbarSeverity('error');
                    setSnackbarMessage(response.data.message || 'Произошла ошибка');
                    setOpenSnackbar(true);
                }
            })
                .catch(function (error) {
                console.log(error);
                setSnackbarSeverity('error');
                setSnackbarMessage("Произошла ошибка при отправке запроса");
                setOpenSnackbar(true);
            });
        }
    };
    return (React.createElement(AuthLayout, { snackbarOpen: openSnackbar, snackbarMessage: snackbarMessage, snackbarSeverity: snackbarSeverity, onCloseSnackbar: handleCloseSnackbar },
        React.createElement("div", { style: { marginBottom: '30px' } },
            React.createElement("div", null,
                React.createElement("div", { style: { marginBottom: '30px' } },
                    React.createElement(Typography, { variant: 'h5', gutterBottom: true }, "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u0430\u0440\u043E\u043B\u044F"),
                    React.createElement(Typography, { variant: 'body1' }, "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u0430\u0448\u0443 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443\u044E \u043F\u043E\u0447\u0442\u0443 \u0434\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0439.")),
                React.createElement("div", null,
                    React.createElement(Stack, { spacing: 1 },
                        React.createElement(TextField, { required: true, id: "outlined-required", label: "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430", onChange: (e) => setEmail(e.target.value), onKeyDown: (e) => handleKeyDown(e.key) })),
                    React.createElement("div", { className: "submitMargin" },
                        React.createElement(Button, { onClick: () => submit(), variant: "contained", disabled: remainingTime > 0 }, remainingTime > 0
                            ? `Повторная отправка через ${Math.floor(remainingTime / 60)}:${(remainingTime % 60).toString().padStart(2, '0')}`
                            : 'Отправить')),
                    React.createElement("div", { style: { marginTop: '20px' } },
                        React.createElement(Typography, { variant: 'body2' },
                            "\u0412\u0441\u043F\u043E\u043C\u043D\u0438\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?",
                            ' ',
                            React.createElement(Link, { href: "/login", style: { cursor: 'pointer' } }, "\u0412\u043E\u0439\u0442\u0438"))))))));
};
export default ForgotPassword;
